<template>
<div class="main-header-page media-print" tabindex="-6">
	<div class="bread" tabindex="-5">
		<router-link
			tag="h1"
			class="header-page-title"
			v-for="(route, routeIndex) in getBreadCrumbs"
			:key="routeIndex"
			tabindex="-1"
			:to="{ name: route.name, params: route.params, query: route.query }"
		>
			<template v-if="width <= 768 && getBreadCrumbs.length >= 4">
				{{ titleBreadCrumb(route) | limitTo(7) }}
			</template>
			<template v-else>
				{{ titleBreadCrumb(route) }}
			</template>
		</router-link>
	</div>
	<div class="header-page-actions" tabindex="-1" v-if="toShow && width > 768">
		<v-btn
			v-if="exportToPdf"
			tabindex="-1"
			@click.prevent="downloadDispatch"
			class="header-page-download-document primary mr-2">
			<img :src="`${$imageUrl}/icon-export-pdf.svg`" alt="" class="align-img">
		</v-btn>
		<v-btn
			v-if="showExcel"
			tabindex="-1"
			class="header-page-download-document primary"
			@click="downloadDocument">
			<img :src="`${$imageUrl}/fill-1.svg`" alt="download" height="17">
		</v-btn>
		<v-btn
			dark
			color="pink"
			tabindex="-1"
			class="btn-action"
			v-if="showClean"
			@click="$emit('on-clean')"
		>
			Limpiar
		</v-btn>
		<slot></slot>
	</div>
	<div class="header-page-actions translate"
		v-if="quotation || sale">
		<v-btn
			flat
			class="header-page-download-document"
			tabindex="-1"
			@click="downloadDocument">
			<img :src="`${$imageUrl}/download.svg`" alt="download" height="17">
		</v-btn>
		<v-btn
			flat
			class="header-page-download-document"
			tabindex="-1"
			@click="print">
			<img :src="`${$imageUrl}/print.svg`" alt="download" height="17">
		</v-btn>
	</div>
	<div v-if="actions" class="action-bar-header" tabindex="-1">
		<v-menu content-class="menu-header-page" tabindex="-1">
			<v-btn class="btn-activator" icon slot="activator" tabindex="-1">
				<v-icon color="indigo darken-1">more_vert</v-icon>
			</v-btn>
			<v-card>
				<action-bar
					:value-disabled="valueDisabled"
					:resource-uri="$route.name"
					tabindex="-1"
					@run-action="openAction"
				/>
			</v-card>
		</v-menu>
	</div>
	<div class="content-space-between" tabindex="-1">
		<div tabindex="-1" class="header-detail-journal-mobile" v-if="detailJournalOpen">
			# {{ codeJournal }} - {{ dateJournal }}
		</div>
		<div v-if="searchHeader" class="header-page-search" tabindex="-1">
			<div class="align-center" tabindex="-1">
				<transition name="slide-fade" tabindex="-1">
					<div v-if="show" class="search-input" tabindex="-1">
						<input
							placeholder="Buscar..."
							@keyup.enter="searchRows"
							@keyup.esc="searchRows"
							v-model="search"
							type="text"
							tabindex="-1"
						/>
						<v-icon class="icon-search-input">search</v-icon>
					</div>
				</transition>
				<div class="border-r" tabindex="-1">
					<v-btn class="btn-search" @click="open" tabindex="-1">
						<img class="" src="/static/img/icons/search.svg" width="17" height="17" alt="">
					</v-btn>
				</div>
			</div>
		</div>
		<div v-if="buttonDelete" class="border-r" tabindex="-1">
			<v-btn class="btn-delete" @click="$emit('delete-journal')" tabindex="-1">
				<img src="/static/img/icons/backspace.svg" width="17" height="17px">
			</v-btn>
		</div>
		<div v-if="buttonFilter" tabindex="-1">
			<v-btn class="btn-filter" @click="$emit('click-filter')" tabindex="-1">
				<img src="/static/img/icons/filter.svg" width="17" height="17px">
			</v-btn>
		</div>
		<div v-if="buttonClose" tabindex="-1">
			<v-btn class="btn-close" @click="$emit('click-close')" tabindex="-1">
				<img src="/static/img/sidebar/close.svg" width="17" height="17px">
			</v-btn>
		</div>
	</div>
</div>
</template>

<script>
import actionBar from '@/components/shared/action-bar/action-bar';
import helper from '@/shared/helper';
import { mapGetters } from 'vuex';

const LOCAL_SEARCH_EVENT = 'on-local-search';
const SEARCH_EVENT = 'on-search-event';

function open() {
	this.show = !this.show;
}

function searchRows($event) {
	const keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	if (this.localSearch) {
		const dataToLocalSearch = this.search.toLowerCase();
		helper.setLocalData(`${this.$attrs.name}::search`, dataToLocalSearch);
		this.$emit(LOCAL_SEARCH_EVENT, dataToLocalSearch);
	} else {
		helper.setLocalData(`${this.$attrs.name}::search`, this.search);
		this.$emit(SEARCH_EVENT, this.search);
	}
}

function mounted() {
	this.setWitdh();
	window.addEventListener('resize', this.setWitdh);
}

function columnsToExport() {
	const columnsSelected = this.columns.filter(column => column.visible
		&& !column.flagVisible);
	const newColumns = columnsSelected.map((col) => {
		const newCol = Object.assign({}, col);
		delete newCol.id;
		delete newCol.visible;
		delete newCol.checked;
		return newCol;
	});
	return newColumns;
}

function dataToExport() {
	let tableDataToExport = [];
	const columnsSelected = this.columns.filter(column => column.visible
		&& !column.flagVisible);
	const columnsValues = columnsSelected.map((colVal) => {
		const newColVal = Object.assign({}, colVal);
		return newColVal.value;
	});
	if (this.rows.length > 0) {
		tableDataToExport = this.rows.map((dataExport) => {
			const newData = Object.assign({}, dataExport);
			const keysData = Object.keys(dataExport);
			keysData.forEach((keyData) => {
				if (columnsValues.every(keyCol => keyCol !== keyData)) {
					delete newData[keyData];
				}
			});
			return newData;
		});
	}
	return tableDataToExport;
}

function downloadDispatch() {
	this.$emit('download-dispatch');
}

function downloadDocument() {
	this.exportTable(this.columnsToExport, this.dataToExport, this.name);
}

function print() {
	window.print();
}

function openAction(item) {
	this.$emit('run-action', item);
}

function setWitdh() {
	this.width = window.innerWidth;
}

function titleBreadCrumb(bc) {
	return bc.title || bc.meta.title;
}

function data() {
	return {
		search: '',
		show: false,
		width: 0,
	};
}

export default {
	name: 'header-page',
	computed: {
		...mapGetters('route', [
			'getBreadCrumbs',
		]),
		columnsToExport,
		dataToExport,
	},
	components: {
		actionBar,
	},
	data,
	methods: {
		open,
		downloadDispatch,
		downloadDocument,
		print,
		openAction,
		searchRows,
		setWitdh,
		titleBreadCrumb,
	},
	mounted,
	props: {
		columns: {
			type: Array,
		},
		exportToPdf: {
			default: false,
			type: Boolean,
		},
		name: {
			type: String,
		},
		rows: {
			type: Array,
		},
		showClean: {
			default: true,
			type: Boolean,
		},
		showExcel: {
			default: true,
			type: Boolean,
		},
		title: {
			type: String,
			required: true,
		},
		toShow: {
			default: false,
			type: Boolean,
		},
		quotation: {
			default: false,
			type: Boolean,
		},
		sale: {
			default: false,
			type: Boolean,
		},
		actions: {
			default: false,
			type: Boolean,
		},
		searchHeader: {
			default: false,
			type: Boolean,
		},
		valueDisabled: {
			default: () => [],
			type: Array,
		},
		buttonDelete: {
			default: false,
			type: Boolean,
		},
		buttonFilter: {
			default: false,
			type: Boolean,
		},
		buttonClose: {
			default: false,
			type: Boolean,
		},
		codeJournal: {
			type: String,
		},
		dateJournal: {
			type: String,
		},
		detailJournalOpen: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.main-header-page {
	@include flex-between;
	background-color: white ;
	border-bottom: 2px solid map-get($colors, base);
	flex-wrap: wrap;
	min-height: 42px;
	padding: 0 12px 0 50px;
	width: 100%;

	.header-page-title {
		color: color(secondary);
		cursor: pointer;
		font-family: map-get($fonts, AvenirRegular);
		font-size: size(small13);
		margin: 0px;
		margin-left: 5px;
		background: white !important;
		@media (max-width: 768px) {
			font-size: size(small10);
		}
	}

	.header-page-title::after {
		content: ' >',
	}

	.header-page-title:last-child {
		cursor: default,
	}

	.header-page-title:last-child::after {
		content: ' ',
	}

	.header-page-actions {
		@include flex-between;
		margin-left: 40px;
		.btn {
			@include txt-config (open-semibold, small10);
			background-color: map-get($colors, orange-btn);
			border-radius: 5px;
			color: white;
			height: 25px;
			min-width: 58px;
			text-transform: capitalize;
		}
		.header-page-download-document {
			@include flex-center;
			min-width: 25px;
			margin: 0px;
		}
	}

	@media (max-width: 768px) {
		padding-left: 10px;
	}

	@media (max-width: 954px) {
		line-height: 4px;
		position: relative;
	}
}

.translate {
	transform: translateX(-200px);
	display: grid !important;
	grid-template-columns: 20px 20px;
	grid-column-gap: 20px;
}

.bread {
	display: flex;

	@media (max-width: 768px) {
		display: none;
	}
}

.action-bar-header {
	display: none;

	@media (max-width: 768px) {
		display: block;
	}
}

.header-page-search {
	display: none;

	@media (max-width: 768px) {
		display: flex;
		justify-content: flex-end;
		width: 100%;
	}
}

.btn-activator {
	bottom: 0;
	margin: auto 0px;
	position: absolute;
	right: 0;
	top: 0;
	width: 24px;
}

.menu-header-page {
	width: 191px;
}

.btn-search {
	background-color: #2c404a !important;
	border-radius: 50% !important;
	min-width: 33px !important;
 	height: 33px !important;
	padding: 0 !important;
}

.search-input {
	align-items: center;
	border: 1px solid #a9bac2 !important;
	background-color: white;
	border-radius: 15px !important;
	color: #a9bac2;
	display: inline-flex;
	font-size: 12px !important;
	font-weight: 500;
	height: 35px;
	margin-right: 11px;
	padding-right: 10px;
	vertical-align: middle;
	width: 100%;
	z-index: 1;

	input {
		color: color(black);
		outline: none;
		padding: 0 10px;
		width: 100%;
	}

	@media (max-width: 768px) {
		&.unique-input {
			width: 50px;
		}
	}
}

.align-center {
	align-items: center;
	display: flex;
	justify-content: flex-end;
	width: 100%;
}

.border-r {
	border-right: 1px solid #e0e5e8;
}

.btn-delete {
	background-color: #ff0000 !important;
	border-radius: 50% !important;
	height: 33px !important;
	padding: 0 !important;
	min-width: 33px !important;

	@media (min-width: 768px) {
		display: none;
	}
}

.content-space-between {
	align-items: center;
	display: flex;
	justify-content: flex-end;
	width: 100%;

	@media (min-width: 768px) {
		display: none;
	}
}

.btn-filter {
	background-color: #5acfc7 !important;
	border-radius: 50% !important;
	height: 33px !important;
	padding: 0 !important;
	min-width: 33px !important;

	@media (min-width: 768px) {
		display: none;
	}
}

.btn-close {
	background-color: white !important;
	border-radius: 50% !important;
	box-shadow: none !important;
	height: 33px !important;
	padding: 0 !important;
	min-width: 33px !important;

	@media (min-width: 768px) {
		display: none;
	}
}

.header-detail-journal-mobile {
	color: #006edb;
	font-weight: 500;
	left: 16px;
	letter-spacing: -0.63px;
	position: absolute;
}
</style>





// WEBPACK FOOTER //
// src/components/shared/header-page.vue